module.exports = __webpack_public_path__ + "img/arrowup.f857ec9d.png";